import { combineReducers } from 'redux';

import CurrentUserReducer from './currentUser';
import TaskReducer from './tasks';
import FieldReportReducer from './fieldReports';
import ReportReducer from './reports';
import WranglerReducer from './wranglers';
import VehicleReducer from './vehicles';
import RidesReducer from './rides';
import LocationReducer from './locations';
import MarketReducer from './markets';
import ZoneReducer from './zones';
import StatReducer from './stats';
import RepairTicketsReducer from './repairTickets';
import RoutesReducer from './routes';
import SnackbarReducer from './snackbar';
import TargetDeploymentReducer from './targetDeployments';
import SettingsReducer from './settings';
import VehicleZonesReducer from './vehicleZones';
import PickupZonesReducer from './pickupZones';
import RunsReducer from './runs';
import FeatureFlagsReducer from './featureFlags';
import RunSchedulesReducer from './runSchedules';

const rootReducer = combineReducers({
  currentUser: CurrentUserReducer,
  tasks: TaskReducer,
  fieldReports: FieldReportReducer,
  wranglers: WranglerReducer,
  vehicles: VehicleReducer,
  rides: RidesReducer,
  locations: LocationReducer,
  markets: MarketReducer,
  zones: ZoneReducer,
  stats: StatReducer,
  reports: ReportReducer,
  repairTickets: RepairTicketsReducer,
  routes: RoutesReducer,
  snackbar: SnackbarReducer,
  targetDeployments: TargetDeploymentReducer,
  settings: SettingsReducer,
  vehicleZones: VehicleZonesReducer,
  pickupZones: PickupZonesReducer,
  runs: RunsReducer,
  featureFlags: FeatureFlagsReducer,
  runSchedules: RunSchedulesReducer,
});

export default rootReducer;
